import moment from "moment-timezone";
import {
  USER_PERMISSIONS,
  READONLY_DATE_FOR_AU,
  READONLY_TIMEZONE,
  READONLY_TEST_EMAILS,
} from "../constants";

const NON_RESIDENTIAL_SPECIALITIES = ["commercial", "business"];
const CORP_EMAIL_REGEX = /@corp\.rh\.com\.au$/i;

export const isCorporate = permissions =>
  permissions === USER_PERMISSIONS.corporateUser;

const normalizeEmail = email => (email || "").trim().toLowerCase();

const isTestEmail = (email, testEmails) =>
  !!email && testEmails.map(normalizeEmail).includes(email);

export const isAuResidentialUser = (
  user,
  testEmails = READONLY_TEST_EMAILS,
) => {
  const email = normalizeEmail(user?.email);
  if (isTestEmail(email, testEmails)) return true; // TEMP: local testing

  const office = user?.office;
  if (!office || office.country !== "Australia") return false;
  if (NON_RESIDENTIAL_SPECIALITIES.includes(office.speciality)) return false;
  if (isCorporate(user.permissions) || CORP_EMAIL_REGEX.test(email))
    return false;
  return true;
};

// Compares real instants, so the result doesn't depend on the browser's timezone
export const isAuReadonlyActive = () =>
  moment().isSameOrAfter(
    moment.tz(READONLY_DATE_FOR_AU, "YYYY-MM-DD", READONLY_TIMEZONE),
  );

export const isAuReadonlyUser = user =>
  isAuResidentialUser(user) && isAuReadonlyActive();
